import { render, staticRenderFns } from "./deal-item.vue?vue&type=template&id=2f21ea68"
import script from "./deal-item.vue?vue&type=script&lang=js"
export * from "./deal-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports